export default __webpack_public_path__ + "static/media/products-artisanpro-comp.4bc272e3.png";